import type { Breakpoint } from '../../../utils/device';

type WidthField = 'coverType' | 'for' | 'livingIn' | 'ageSection' | 'annualIncome';
type FieldWidthRules = Record<WidthField, Partial<Record<Breakpoint, number>>>;

const FIELD_WIDTH_RULES: FieldWidthRules = {
  ageSection: { lg: 9, md: 8.9, sm: 9, xs: 9 },
  annualIncome: { lg: 18, md: 16, sm: 15.625, xs: 15.625 },
  coverType: { lg: 12, md: 11.5, sm: 11.375, xs: 11.375 },
  for: { lg: 10.5, md: 8, sm: 11.625, xs: 11.625 },
  livingIn: { lg: 8.6, md: 7.9, sm: 10, xs: 10 },
};

export const getFieldWidth = (field: WidthField, breakpoint: Breakpoint, fallback: number) =>
  FIELD_WIDTH_RULES[field][breakpoint] ?? fallback;
